import type { Product } from "@/types/product";

/** Sample product set for "Reset demo data" on upload page */
export const DEMO_PRODUCTS: Product[] = [
  {
    id: "demo-1",
    sku: "SHIRT-001",
    title: "Classic Cotton T-Shirt",
    description: "Soft, breathable cotton tee. Unisex fit.",
    price: 19.99,
    currency: "USD",
    category: "Apparel",
    imageUrl: "",
    inventory: 50,
    tags: ["cotton", "casual"],
  },
  {
    id: "demo-2",
    sku: "SHOE-002",
    title: "Running Sneakers",
    description: "Lightweight runners for daily jogs.",
    price: 89.99,
    currency: "USD",
    category: "Footwear",
    imageUrl: "",
    inventory: 20,
    tags: ["sports", "running"],
  },
  {
    id: "demo-3",
    sku: "BAG-003",
    title: "Canvas Tote Bag",
    description: "Spacious tote for books and groceries.",
    price: 24.5,
    currency: "USD",
    category: "Accessories",
    imageUrl: "",
    inventory: 100,
    tags: ["eco", "tote"],
  },
  {
    id: "demo-4",
    sku: "WATCH-004",
    title: "Minimalist Watch",
    description: "Simple analog watch with leather strap.",
    price: 149.0,
    currency: "USD",
    category: "Accessories",
    imageUrl: "",
    inventory: 15,
    tags: ["watch", "minimal"],
  },
  {
    id: "demo-5",
    sku: "MUG-005",
    title: "Ceramic Coffee Mug",
    description: "12 oz ceramic mug, dishwasher safe.",
    price: 12.99,
    currency: "USD",
    category: "Home",
    imageUrl: "",
    inventory: 0,
    tags: ["kitchen", "mug"],
  },
];
